import React from 'react'
import ClassNames from 'classnames'
import { IBuildedTourGroup } from 'utils/weeklyTypes'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'
interface IProps {
  tour_group: IBuildedTourGroup
  waitConnecting: boolean
  handleConnect: (tour_group: any) => void
}

export const ConnectIconButton = ({ tour_group, waitConnecting, handleConnect }: IProps) => {
  const getConnectIconClassName = React.useCallback(
    ({ assignedGuide, connected, allTaskDone }) => {
      return ClassNames('icon', {
        connecting: waitConnecting,
        unlinked: !connected,
        disabled: !connected && !allTaskDone,
        unAssigned: !assignedGuide,
      })
    },
    [waitConnecting]
  )
  return (
    <StyledConnectIconButton>
      <SvgIcon
        name={tour_group.connected ? 'connection_linked' : 'connection_unlinked'}
        ariaHidden={true}
        onClick={handleConnect}
        role="button"
        className={getConnectIconClassName(tour_group)}
      />
    </StyledConnectIconButton>
  )
}

const StyledConnectIconButton = styled.div`
  .icon {
    width: 48px;
    height: 24px;
    color: transparent;
    margin-right: 8px;
    transition: opacity 0.2s;

    &.connecting,
    &.disabled {
      opacity: 0.5;
    }

    &.unlinked:hover {
      opacity: 0.75;
      cursor: pointer;
    }

    &.unAssigned {
      opacity: 0.25;
    }
    &.disabled,
    &.unAssigned {
      pointer-events: none;
      cursor: not-allowed;
    }
  }
`
